<template>
  <div>
    <el-table :data="listData" class="tableArea" style="width: 100%" border :span-method="objectSpanMethod">
      <el-table-column label="序号" prop="SN" width="50px"></el-table-column>
      <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
      <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
      <el-table-column label="档口" prop="DK_NAME"></el-table-column>
      <el-table-column label="退货商品" prop="PRODUCT_NAME"></el-table-column>
      <el-table-column label="退货总数" prop="TOTAL_RETURN_COUNT"></el-table-column>
      <el-table-column label="退货批次" prop="BATCH"></el-table-column>
      <el-table-column label="退货数量" prop="BATCH_COUNT" min-width="80px"></el-table-column>
      <el-table-column label="退货理由" prop="REASON"></el-table-column>
      <el-table-column label="申请时间" prop="CREATE_TIME"></el-table-column>
      <el-table-column label="申请人" prop="NAME"></el-table-column>
      <el-table-column label="联系电话" prop="CELLPHONE"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="text" icon="el-icon-edit" @click="openEdit(scope.row)">出库</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryHaveReturnFun, returnDataFun } from 'api/returnCheck';

export default {
  data() {
    return {
      listData: [],
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      rowList: [],
      spanArr: [],
      position: 0,
    };
  },
  methods: {
    handleCurrentChange() {
      this.queryData();
    },
    // -----------------------------------拉取数据
    queryData() {
      const params = {
        STATUS: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      queryHaveReturnFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.listData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
            this.rowspan();
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // -----------------------------------出库按钮
    openEdit(row) {
      this.$confirm('确定出库吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const submitArr = this.listData.map((item, index) => ({ BATCH: item.BATCH, BATCH_COUNT: item.BATCH_COUNT, PRODUCT_CODE: item.PRODUCT_CODE }));
        const params = {
          RETURN_ID: row.RETURN_ID,
          DELIVER_ID: row.DELIVER_ID,
          ORDER_ID: row.ORDER_ID,
          PRODUCT_ARRAY: submitArr,
          SUPPLIER_ID: Number(sessionStorage.getItem('SUPPLIER_ID')),
        };
        returnDataFun(params)
          .then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消操作' });
      });
    },
    rowspan() {
      this.spanArr = [];
      this.listData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.listData[index].SN === this.listData[index - 1].SN) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 5) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 8) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 9) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 10) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 11) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 12) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
};
</script>
<style  scoped>
.el-select {
  margin-right: 15px;
}

.el-input {
  margin-right: 15px;
  width: 200px;
}

.tableArea {
  margin-top: 20px;
}

i[class^="el-icon"] {
  margin-right: 5px;
  font-size: 16px;
  cursor: pointer;
}

.modify_table td {
  padding: 10px;
}

.item_title {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/returnCheck/returnOutDetail.vue